import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Fade,
  Grid,
  List,
  ListItem,
  Typography
} from "@mui/material";
import {Check, Remove} from "@mui/icons-material";
import AnimationGlobal from "../../../components/Shared/animations/AnimationGlobal";
import successAnimation from "../../../assets/animations/success.json";
import React, {useContext} from "react";
import Context from "../../../contexts/Context";

const ConclusionCard = () => {
  const { dataProvider } = useContext(Context)
  const { bankRegister, pixRegister } = dataProvider || {}

  function avatarType(param) {
    const color = param  ? 'success' : 'warning';
    const icon = param ? <Check sx={{color: 'white', fontSize: '2rem'}}/> :
      <Remove sx={{color: 'white', fontSize: '2rem'}}/>;

    return (
      <Avatar sx={{ backgroundColor: `${color}.main`, mr: '0.5rem' }}>
        {icon}
      </Avatar>
    )
  }

  // const pixAltText = pixRegister ? 'Foi registrado ao menos uma chave Pix' :
  //   'Não foi registrada nenhuma chave Pix'

  const bankAltText = bankRegister ? 'Foi registrada ao menos uma conta bancária ou chave PIX' :
    'Não foi registrada nenhuma conta ou chave PIX'


    return (
    <Grid item xs={12}>
    <Card>
      <Fade
        in={true}
        mountOnEnter
        unmountOnExit
        timeout={300}
      >
        <Box>
          <CardHeader
            avatar={<Avatar sx={{ bgcolor: 'primary.main' }}><Check/></Avatar>}
            title={'Conclusão'}/>
          <Divider sx={{ mb: '.3rem' }}/>
          <CardContent
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: '1rem', flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <AnimationGlobal
              size={'200px'}
              animation={successAnimation}
              fontStyles={{mb: '1rem'}}
              fontSize={'20px'}
            />
            <List
              sx={{
                paddingBottom: '5rem'
              }}
            >
              <ListItem sx={{display: 'flex'}}>
                <Avatar sx={{backgroundColor: 'success.main', mr: '0.5rem'}}>
                  <Check sx={{color: 'white', fontSize: '2rem'}} />
                </Avatar>
                <Typography variant="body1" sx={{fontSize: '1.5rem'}}>
                  Beneficiário cadastrado
                </Typography>
              </ListItem>
              <ListItem sx={{display: 'flex'}}>
                {avatarType(bankRegister)}
                <Typography variant="body1" sx={{fontSize: '1.5rem'}}>
                  {bankAltText}
                </Typography>
              </ListItem>
              {/*<ListItem sx={{display: 'flex'}}>*/}
              {/*  {avatarType(pixRegister)}*/}
              {/*  <Typography variant="body1" sx={{fontSize: '1.5rem'}}>*/}
              {/*    {pixAltText}*/}
              {/*  </Typography>*/}
              {/*</ListItem>*/}
            </List>
          </CardContent>
        </Box>
      </Fade>
    </Card>
    </Grid>
  )
}

export default ConclusionCard